<template>
    <div>
        <v-row>
            <v-col cols="6">
                <h1 class="headline font-weight-light mb-3">Packinglist</h1>
            </v-col>
            <v-col cols="6" class="text-right">
                <v-btn @click=";(dialogemail = true), (selectedProvince = [])"
                    ><v-icon left> mdi-email-send</v-icon>Send Email</v-btn
                >
            </v-col>
        </v-row>

        <v-row>
            <v-col
                cols="12"
                sm="6"
                md="2"
                v-for="(showbranch, i) in showbranch"
                :key="i"
            >
                <v-tooltip top>
                    <template v-slot:activator="{ on }">
                        <v-btn
                            v-if="showbranch.packing_status == 'Pending'"
                            color="grey"
                            v-on="on"
                            @click="selected(i, showbranch.branch_id)"
                        >
                            <v-icon
                                :style="
                                    buttonactive[i] == '1'
                                        ? 'background: red;background: -webkit-linear-gradient(left top, red, yellow); background: -o-linear-gradient(bottom right, red, yellow);background: -moz-linear-gradient(bottom right, red, yellow); background: linear-gradient(to bottom right, red, yellow);'
                                        : 'white'
                                "
                                small
                                left
                                >{{
                                    buttonactive[i] == "1"
                                        ? "mdi-truck-fast"
                                        : "mdi-truck"
                                }}</v-icon
                            ><label
                                style="font-size: 12px; color: white"
                                v-if="showbranch.branch_name.length > 9"
                                >{{ showbranch.branch_name.substr(0, 8) }}...
                            </label>
                            <label style="font-size: 12px; color: white" v-else
                                >{{ showbranch.branch_name }}
                            </label>
                        </v-btn>
                        <v-btn
                            v-if="showbranch.packing_status == 'Packing'"
                            color="orange"
                            v-on="on"
                            @click="selected(i, showbranch.branch_id)"
                        >
                            <v-icon
                                :style="
                                    buttonactive[i] == '1'
                                        ? 'background: red;background: -webkit-linear-gradient(left top, red, yellow); background: -o-linear-gradient(bottom right, red, yellow);background: -moz-linear-gradient(bottom right, red, yellow); background: linear-gradient(to bottom right, red, yellow);'
                                        : 'white'
                                "
                                small
                                left
                                >{{
                                    buttonactive[i] == "1"
                                        ? "mdi-truck-fast"
                                        : "mdi-truck"
                                }}</v-icon
                            ><label
                                style="font-size: 12px; color: white"
                                v-if="showbranch.branch_name.length > 9"
                                >{{ showbranch.branch_name.substr(0, 8) }}...
                            </label>
                            <label style="font-size: 12px; color: white" v-else
                                >{{ showbranch.branch_name }}
                            </label>
                        </v-btn>
                        <v-btn
                            v-if="showbranch.packing_status == 'Done'"
                            color="green"
                            v-on="on"
                            @click="selected(i, showbranch.branch_id)"
                        >
                            <v-icon
                                :style="
                                    buttonactive[i] == '1'
                                        ? 'background: red;background: -webkit-linear-gradient(left top, red, yellow); background: -o-linear-gradient(bottom right, red, yellow);background: -moz-linear-gradient(bottom right, red, yellow); background: linear-gradient(to bottom right, red, yellow);'
                                        : 'white'
                                "
                                small
                                left
                                >{{
                                    buttonactive[i] == "1"
                                        ? "mdi-truck-fast"
                                        : "mdi-truck"
                                }}</v-icon
                            ><label
                                style="font-size: 12px; color: white"
                                v-if="showbranch.branch_name.length > 9"
                                >{{ showbranch.branch_name.substr(0, 8) }}...
                            </label>
                            <label style="font-size: 12px; color: white" v-else
                                >{{ showbranch.branch_name }}
                            </label>
                        </v-btn>
                    </template>
                    <span>{{ showbranch.branch_name }} </span>
                </v-tooltip>
            </v-col>
        </v-row>
        <v-dialog v-model="dialogemail" max-width="1440px">
            <v-card>
                <v-card-title>
                    <span class="headline">Sent To Email </span>
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col>
                            <v-select
                                v-model="selectedProvince"
                                :items="showbranch"
                                item-text="branch_name"
                                item-value="branch_id"
                                label="Province"
                                multiple
                            >
                                <template v-slot:prepend-item>
                                    <v-list-item ripple @click="toggle">
                                        <v-list-item-action>
                                            <v-icon
                                                :color="
                                                    selectedProvince.length > 0
                                                        ? 'indigo darken-4'
                                                        : ''
                                                "
                                            >
                                                {{ icon }}
                                            </v-icon>
                                        </v-list-item-action>
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                Select All
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-divider class="mt-2"></v-divider>
                                </template>
                                <template v-slot:append-item>
                                    <v-divider class="mb-2"></v-divider>
                                    <v-list-item disabled>
                                        <v-list-item-avatar
                                            color="grey lighten-3"
                                        >
                                            <v-icon>
                                                mdi-crosshairs-gps
                                            </v-icon>
                                        </v-list-item-avatar>

                                        <v-list-item-content v-if="allprovince">
                                            <v-list-item-title>
                                                Select Province All
                                                {{ selectedProvince.length }}
                                            </v-list-item-title>
                                        </v-list-item-content>

                                        <v-list-item-content
                                            v-else-if="someprovince"
                                        >
                                            <v-list-item-title>
                                                Province Count
                                            </v-list-item-title>
                                            <v-list-item-subtitle>
                                                {{ selectedProvince.length }}
                                            </v-list-item-subtitle>
                                        </v-list-item-content>

                                        <v-list-item-content v-else>
                                            <v-list-item-title>
                                                Select Province?
                                            </v-list-item-title>
                                            <v-list-item-subtitle>
                                                Go ahead, make a selection
                                                above!
                                            </v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>
                                </template>
                            </v-select>
                        </v-col>
                    </v-row>
                </v-card-text>

                <div></div>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="blue darken-1"
                        text
                        @click="SentEmailProvince()"
                        >Sent</v-btn
                    >

                    <v-btn
                        color="blue darken-1"
                        text
                        @click="dialogemail = false"
                        >Close</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-row>
            <v-col cols="12" class="col-6">
                <v-row>
                    <div>
                        <h4
                            style="margin-bottom: 20px"
                            v-if="
                                this.checkbutton == 1 &&
                                this.databranch.pending.length > 0
                            "
                        >
                            Packing Pending
                            <v-btn
                                rounded
                                small
                                color="red"
                                @click="saveboxtoproject()"
                                class="ml-5"
                            >
                                <v-icon class="mr-1" dark small color="white"
                                    >mdi-content-save</v-icon
                                ><label style="color: white; font-size: 12px"
                                    >save</label
                                >
                            </v-btn>
                        </h4>
                        <v-simple-table
                            class="table-inv"
                            cellpadding="0"
                            cellspacing="0"
                            style="width: 100%"
                        >
                            <template
                                v-slot:default
                                v-if="
                                    this.checkbutton == 1 &&
                                    this.databranch.pending.length > 0
                                "
                            >
                                <thead>
                                    <tr class="col-tr-1">
                                        <th
                                            style="
                                                border-left: 2px solid black;
                                                border-top: 2px solid black;
                                                border-bottom: 2px solid black;
                                            "
                                        >
                                            <v-checkbox
                                                color="red"
                                                v-model="chkboxselectall"
                                                @change="selectallpacking()"
                                            ></v-checkbox>
                                        </th>
                                        <th
                                            style="
                                                border-top: 2px solid black;
                                                border-bottom: 2px;
                                                border-bottom: 2px solid black;
                                            "
                                        >
                                            Type
                                        </th>
                                        <th
                                            style="
                                                border-top: 2px solid black;
                                                border-bottom: 2px;
                                                border-bottom: 2px solid black;
                                            "
                                        >
                                            CaseID
                                        </th>
                                        <th
                                            style="
                                                border-top: 2px solid black;
                                                border-bottom: 2px;
                                                border-bottom: 2px solid black;
                                            "
                                        >
                                            S/N
                                        </th>
                                        <th
                                            style="
                                                border-top: 2px solid black;
                                                border-bottom: 2px;
                                                border-bottom: 2px solid black;
                                            "
                                        >
                                            Singlepart
                                        </th>

                                        <th
                                            style="
                                                border-top: 2px solid black;
                                                border-bottom: 2px;
                                                border-bottom: 2px solid black;
                                            "
                                        >
                                            Description
                                        </th>

                                        <th
                                            style="
                                                border-top: 2px solid black;
                                                border-bottom: 2px;
                                                border-bottom: 2px solid black;
                                            "
                                        >
                                            Qty
                                        </th>
                                        <th
                                            style="
                                                border-right: 2px solid black;
                                                border-top: 2px solid black;
                                                border-bottom: 2px solid black;
                                            "
                                        >
                                            Req.By
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="(
                                            databranchpending, idx
                                        ) in databranch.pending"
                                        :key="idx"
                                    >
                                        <td
                                            align="center"
                                            style="
                                                text-align: center;
                                                color: black;
                                                font-size: 14px;
                                                font-weight: 500;
                                                border-left: 2px solid black;
                                                border-bottom: 2px solid black;
                                            "
                                        >
                                            <!-- <v-select v-model="" :items="tobox"> </v-select> -->
                                            <v-checkbox
                                                v-model="
                                                    databranchpending.select
                                                "
                                                :value="
                                                    databranchpending.maincase_id
                                                "
                                                color="red"
                                            ></v-checkbox>
                                        </td>
                                        <td
                                            align="center"
                                            style="
                                                border-left: 1px solid black;
                                                color: black;
                                                font-size: 14px;
                                                font-weight: 400;
                                                border-bottom: 2px solid black;
                                                border-right: 1px solid black;
                                            "
                                        >
                                            {{ databranchpending.type_name }}
                                        </td>
                                        <td
                                            align="center"
                                            style="
                                                color: black;
                                                font-size: 14px;
                                                font-weight: 400;
                                                border-bottom: 2px solid black;
                                                border-right: 1px solid black;
                                            "
                                        >
                                            {{ databranchpending.case_id }}
                                        </td>
                                        <td
                                            align="center"
                                            style="
                                                color: black;
                                                font-size: 14px;
                                                font-weight: 400;
                                                border-bottom: 2px solid black;
                                                border-right: 1px solid black;
                                            "
                                        >
                                            {{ databranchpending.serial }}
                                        </td>
                                        <td
                                            align="center"
                                            style="
                                                color: black;
                                                font-size: 14px;
                                                font-weight: 400;
                                                border-bottom: 2px solid black;
                                                border-right: 1px solid black;
                                            "
                                        >
                                            {{ databranchpending.singlepart }}
                                        </td>
                                        <td
                                            align="center"
                                            style="
                                                color: black;
                                                font-size: 14px;
                                                font-weight: 400;
                                                border-bottom: 2px solid black;
                                                border-right: 1px solid black;
                                            "
                                        >
                                            <div>
                                                <span>{{
                                                    databranchpending.description
                                                }}</span>
                                            </div>
                                        </td>

                                        <td
                                            align="center"
                                            style="
                                                color: black;
                                                font-size: 14px;
                                                font-weight: 400;
                                                border-bottom: 2px solid black;
                                                border-right: 1px solid black;
                                            "
                                        >
                                            {{ databranchpending.qty }}
                                        </td>
                                        <td
                                            align="center"
                                            style="
                                                color: black;
                                                font-size: 14px;
                                                font-weight: 400;
                                                border-bottom: 2px solid black;
                                                border-right: 2px solid black;
                                            "
                                        >
                                            <div>
                                                <span>{{
                                                    databranchpending.created_name
                                                }}</span>
                                                <br /><span>{{
                                                    databranchpending.created_date
                                                }}</span>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </div>
                </v-row>
            </v-col>

            <v-col
                cols="12"
                class="col-6"
                v-if="this.checkbutton == 1"
                style="margin-top: -30px"
            >
                <v-row>
                    <v-col cols="1" md="7"></v-col>
                    <v-col cols="3" md="2"> </v-col>

                    <v-col cols="12" md="2" style="margin-top: 25px"> </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-simple-table
                            cellpadding="0"
                            cellspacing="0"
                            style="margin-left: -10px"
                            class="table-inv"
                        >
                            <template v-slot:default>
                                <tbody>
                                    <table
                                        id="TB-box-1"
                                        cellpadding="0"
                                        cellspacing="0"
                                        style="
                                            border-collapse: collapse;
                                            border-left: 2px solid black;
                                            border-right: 2px solid black;
                                            border-top: 2px solid black;
                                        "
                                        border="1"
                                    >
                                        <tr style="background-color: #dcf7d2">
                                            <th colspan="9">
                                                <v-row>
                                                    <v-col cols="3" md="3">
                                                        <img
                                                            src="../../assets/logistic/acaciaicon1.png"
                                                            width="70%"
                                                        />
                                                    </v-col>
                                                    <v-col cols="1" md="2">
                                                    </v-col>
                                                    <v-col cols="1" md="2">
                                                    </v-col>
                                                    <!-- <v-col cols="2" md="2">
                            <span>
                              <v-btn
                                rounded
                                small
                                @click="print()"
                                style="text-align:right;margin-left:70%;margin-top:-5%"
                              >
                                <v-icon class="mr-1" dark small
                                  >mdi-content-save</v-icon
                                >
                                save</v-btn
                              >
                            </span>
                          </v-col>
                          <v-col cols="3" md="2">
                            <span>
                              <v-btn
                                rounded
                                small
                                @click="print()"
                                style="text-align:right;margin-left:70%;margin-top:-5%"
                              >
                                <v-icon class="mr-1" dark small
                                  >mdi-printer</v-icon
                                >
                                Print</v-btn
                              >
                            </span>
                          </v-col> -->
                                                </v-row>
                                                <v-form
                                                    method="post"
                                                    id="nativeForm"
                                                    v-model="validacacia"
                                                >
                                                    <v-row>
                                                        <v-col cols="4">
                                                            <v-text-field
                                                                v-model="
                                                                    consignmentacacia
                                                                "
                                                                label="CONSIGNMENT"
                                                                clearable
                                                                :rules="
                                                                    consignmentnoacacia
                                                                "
                                                                required
                                                            ></v-text-field
                                                        ></v-col>

                                                        <v-col cols="4">
                                                            <v-text-field
                                                                v-model="
                                                                    totalacacia
                                                                "
                                                                @keypress="
                                                                    chkNum()
                                                                "
                                                                label="TOTAL BOX"
                                                                clearable
                                                                :rules="
                                                                    totalboxacacia
                                                                "
                                                                required
                                                            ></v-text-field
                                                        ></v-col>
                                                        <v-col cols="2">
                                                            <v-btn
                                                                rounded
                                                                small
                                                                color="cyan"
                                                                :disabled="
                                                                    !validacacia
                                                                "
                                                                v-if="
                                                                    databranch
                                                                        .box_acacia
                                                                        .length !=
                                                                    0
                                                                "
                                                                @click="
                                                                    savenameboxsub(
                                                                        databranch
                                                                            .box_acacia[0]
                                                                            .packing_no,
                                                                        consignmentacacia,
                                                                        totalacacia
                                                                    )
                                                                "
                                                            >
                                                                <v-icon
                                                                    class="mr-1"
                                                                    dark
                                                                    small
                                                                    color="white"
                                                                    >mdi-content-save</v-icon
                                                                ><label
                                                                    style="
                                                                        color: white;
                                                                        font-size: 12px;
                                                                    "
                                                                    >save</label
                                                                >
                                                            </v-btn>
                                                        </v-col>

                                                        <v-col
                                                            cols="2"
                                                            v-if="
                                                                databranch
                                                                    .box_acacia
                                                                    .length == 0
                                                            "
                                                        >
                                                        </v-col>
                                                        <v-col cols="2" v-else>
                                                            <v-btn
                                                                rounded
                                                                v-if="
                                                                    databranch
                                                                        .box_acacia[0]
                                                                        .consignment_no !=
                                                                        null &&
                                                                    databranch
                                                                        .box_acacia[0]
                                                                        .total_box !=
                                                                        null
                                                                "
                                                                small
                                                                :to="
                                                                    '/Logistic/DocLogistic/' +
                                                                    databranch
                                                                        .box_acacia[0]
                                                                        .packing_no +
                                                                    '/' +
                                                                    'ACACIA'
                                                                "
                                                                target="_blank"
                                                            >
                                                                <v-icon
                                                                    class="mr-1"
                                                                    dark
                                                                    small
                                                                    >mdi-printer</v-icon
                                                                >
                                                                Print</v-btn
                                                            >
                                                        </v-col>
                                                    </v-row>
                                                </v-form>
                                            </th>
                                        </tr>
                                        <tr align="center">
                                            <th
                                                style="
                                                    text-align: center;
                                                    border-top: 2px solid black;
                                                    border-bottom: 2px solid
                                                        black;
                                                    font-size: 13px;
                                                    color: black;
                                                "
                                            >
                                                Type
                                            </th>
                                            <th
                                                style="
                                                    text-align: center;
                                                    border-bottom: 2px solid
                                                        black;
                                                    font-size: 13px;
                                                    color: black;
                                                "
                                            >
                                                CaseID
                                            </th>
                                            <th
                                                style="
                                                    border-top: 2px solid black;
                                                    border-bottom: 2px;
                                                    border-bottom: 2px solid
                                                        black;
                                                "
                                            >
                                                S/N
                                            </th>
                                            <th
                                                style="
                                                    border-top: 2px solid black;
                                                    border-bottom: 2px;
                                                    border-bottom: 2px solid
                                                        black;
                                                "
                                            >
                                                Singlepart
                                            </th>
                                            <th
                                                style="
                                                    text-align: center;
                                                    border-bottom: 2px solid
                                                        black;
                                                    font-size: 13px;
                                                    color: black;
                                                "
                                            >
                                                Description
                                            </th>

                                            <th
                                                style="
                                                    text-align: center;
                                                    border-bottom: 2px solid
                                                        black;
                                                    font-size: 13px;
                                                    color: black;
                                                "
                                            >
                                                Qty
                                            </th>
                                            <th
                                                style="
                                                    text-align: center;
                                                    border-bottom: 2px solid
                                                        black;
                                                    font-size: 13px;
                                                    color: black;
                                                "
                                            >
                                                Req.By
                                            </th>
                                            <th
                                                width="20%"
                                                style="
                                                    text-align: center;
                                                    border-right: 2px solid
                                                        black;
                                                    border-bottom: 2px solid
                                                        black;
                                                    font-size: 13px;
                                                    color: black;
                                                "
                                            >
                                                Return
                                            </th>
                                        </tr>
                                        <tr
                                            v-if="
                                                databranch.box_acacia.length ==
                                                0
                                            "
                                        ></tr>
                                        <tr
                                            v-else
                                            v-for="(
                                                databranchboxacacia, i
                                            ) in databranch.box_acacia[0]
                                                .packing"
                                            :key="i"
                                        >
                                            <td
                                                align="center"
                                                style="
                                                    border-bottom: 2px solid
                                                        black;
                                                    border-right: 1px solid
                                                        black;
                                                    color: black;
                                                    font-weight: 400;
                                                "
                                            >
                                                {{
                                                    databranchboxacacia.type_name
                                                }}
                                            </td>
                                            <td
                                                align="center"
                                                style="
                                                    border-bottom: 2px solid
                                                        black;
                                                    border-right: 1px solid
                                                        black;
                                                    color: black;
                                                    font-weight: 400;
                                                "
                                            >
                                                {{
                                                    databranchboxacacia.case_id
                                                }}
                                            </td>
                                            <td
                                                align="center"
                                                style="
                                                    border-bottom: 2px solid
                                                        black;
                                                    border-right: 1px solid
                                                        black;
                                                    color: black;
                                                    font-weight: 400;
                                                "
                                            >
                                                {{ databranchboxacacia.serial }}
                                            </td>
                                            <td
                                                align="center"
                                                style="
                                                    border-bottom: 2px solid
                                                        black;
                                                    border-right: 1px solid
                                                        black;
                                                    color: black;
                                                    font-weight: 400;
                                                "
                                            >
                                                {{
                                                    databranchboxacacia.singlepart
                                                }}
                                            </td>
                                            <td
                                                align="center"
                                                style="
                                                    border-bottom: 2px solid
                                                        black;
                                                    border-right: 1px solid
                                                        black;
                                                    color: black;
                                                    font-weight: 400;
                                                "
                                            >
                                                <div>
                                                    <span>{{
                                                        databranchboxacacia.description
                                                    }}</span>
                                                </div>
                                            </td>
                                            <td
                                                align="center"
                                                style="
                                                    border-bottom: 2px solid
                                                        black;
                                                    border-right: 1px solid
                                                        black;
                                                    color: black;
                                                    font-weight: 400;
                                                "
                                            >
                                                {{ databranchboxacacia.qty }}
                                            </td>
                                            <td
                                                align="center"
                                                style="
                                                    border-bottom: 2px solid
                                                        black;
                                                    border-right: 1px solid
                                                        black;
                                                    color: black;
                                                    font-weight: 400;
                                                "
                                            >
                                                <div>
                                                    <span>{{
                                                        databranchboxacacia.created_name
                                                    }}</span>
                                                    <br /><span>{{
                                                        databranchboxacacia.created_date
                                                    }}</span>
                                                </div>
                                            </td>
                                            <td
                                                align="center"
                                                style="
                                                    border-bottom: 2px solid
                                                        black;
                                                    border-right: 2px solid
                                                        black;
                                                    color: black;
                                                    font-weight: 400;
                                                "
                                            >
                                                <v-btn
                                                    color="blue-grey"
                                                    class="ma-2 white--text"
                                                    fab
                                                    x-small
                                                    @click="
                                                        ReturnPending(
                                                            databranchboxacacia.detail_id
                                                        )
                                                    "
                                                >
                                                    <v-icon dark
                                                        >mdi-reply</v-icon
                                                    >
                                                </v-btn>
                                            </td>
                                        </tr>
                                    </table>

                                    <table
                                        id="TB-box-1"
                                        cellpadding="0"
                                        cellspacing="0"
                                        style="
                                            margin-top: 20px;
                                            border-collapse: collapse;
                                            border-left: 2px solid black;
                                            border-right: 2px solid black;
                                            border-top: 2px solid black;
                                        "
                                        border="1"
                                    >
                                        <tr style="background-color: #fae1de">
                                            <th colspan="9">
                                                <v-row>
                                                    <v-col cols="3" md="3">
                                                        <img
                                                            src="../../assets/logistic/aserveicon.png"
                                                            width="65%"
                                                        />
                                                    </v-col>
                                                    <v-col cols="1" md="2">
                                                    </v-col>
                                                    <v-col cols="1" md="2">
                                                    </v-col>
                                                    <!-- <v-col cols="2" md="2">
                            <right>
                              <span>
                                <v-btn
                                  rounded
                                  small
                                  @click="print()"
                                  style="text-align:right;margin-left:70%;margin-top:-5%"
                                >
                                  <v-icon class="mr-1" dark small
                                    >mdi-content-save</v-icon
                                  >
                                  save</v-btn
                                >
                              </span>
                            </right>
                          </v-col>
                          <v-col cols="3" md="2">
                            <right>
                              <span>
                                <v-btn
                                  rounded
                                  small
                                  @click="print()"
                                  style="text-align:right;margin-left:70%;margin-top:-5%"
                                >
                                  <v-icon class="mr-1" dark small
                                    >mdi-printer</v-icon
                                  >
                                  Print</v-btn
                                >
                              </span>
                            </right>
                          </v-col> -->
                                                </v-row>
                                                <v-form
                                                    method="post"
                                                    id="nativeForm"
                                                    v-model="validaserve"
                                                >
                                                    <v-row>
                                                        <v-col cols="4">
                                                            <v-text-field
                                                                label="CONSIGNMENT"
                                                                v-model="
                                                                    consignmentags
                                                                "
                                                                :rules="
                                                                    consignmentnoaserve
                                                                "
                                                                required
                                                                clearable
                                                            ></v-text-field
                                                        ></v-col>

                                                        <v-col cols="4">
                                                            <v-text-field
                                                                label="TOTAL BOX"
                                                                @keypress="
                                                                    chkNum()
                                                                "
                                                                v-model="
                                                                    totalags
                                                                "
                                                                :rules="
                                                                    totalboxaserve
                                                                "
                                                                clearable
                                                            ></v-text-field
                                                        ></v-col>
                                                        <v-col cols="2">
                                                            <v-btn
                                                                rounded
                                                                small
                                                                color="cyan"
                                                                v-if="
                                                                    databranch
                                                                        .box_ags
                                                                        .length !=
                                                                    0
                                                                "
                                                                :disabled="
                                                                    !validaserve
                                                                "
                                                                @click="
                                                                    savenameboxsub(
                                                                        databranch
                                                                            .box_ags[0]
                                                                            .packing_no,
                                                                        consignmentags,
                                                                        totalags
                                                                    )
                                                                "
                                                            >
                                                                <v-icon
                                                                    class="mr-1"
                                                                    dark
                                                                    small
                                                                    color="white"
                                                                    >mdi-content-save</v-icon
                                                                ><label
                                                                    style="
                                                                        color: white;
                                                                        font-size: 12px;
                                                                    "
                                                                    >save</label
                                                                >
                                                            </v-btn>
                                                        </v-col>
                                                        <v-col
                                                            cols="2"
                                                            v-if="
                                                                databranch
                                                                    .box_ags
                                                                    .length == 0
                                                            "
                                                        >
                                                        </v-col>
                                                        <v-col cols="2" v-else>
                                                            <v-btn
                                                                v-if="
                                                                    databranch
                                                                        .box_ags[0]
                                                                        .consignment_no !=
                                                                        null &&
                                                                    databranch
                                                                        .box_ags[0]
                                                                        .total_box !=
                                                                        null
                                                                "
                                                                rounded
                                                                small
                                                                :to="
                                                                    '/Logistic/DocLogistic/' +
                                                                    databranch
                                                                        .box_ags[0]
                                                                        .packing_no +
                                                                    '/' +
                                                                    'ASERVE'
                                                                "
                                                                target="_blank"
                                                            >
                                                                <v-icon
                                                                    class="mr-1"
                                                                    dark
                                                                    small
                                                                    >mdi-printer</v-icon
                                                                >
                                                                Print</v-btn
                                                            >
                                                        </v-col>
                                                    </v-row>
                                                </v-form>
                                            </th>
                                        </tr>
                                        <tr
                                            align="center"
                                            v-if="
                                                databranch.box_ags.length == 0
                                            "
                                        >
                                            <th
                                                style="
                                                    text-align: center;
                                                    border-top: 2px solid black;
                                                    border-bottom: 4px solid
                                                        black;
                                                    font-size: 13px;
                                                    color: black;
                                                "
                                            >
                                                Type
                                            </th>
                                            <th
                                                style="
                                                    text-align: center;
                                                    border-bottom: 4px solid
                                                        black;
                                                    font-size: 13px;
                                                    color: black;
                                                "
                                            >
                                                CaseID
                                            </th>
                                            <th
                                                style="
                                                    border-top: 2px solid black;
                                                    border-bottom: 4px solid
                                                        black;
                                                "
                                            >
                                                S/N
                                            </th>
                                            <th
                                                style="
                                                    border-top: 2px solid black;
                                                    border-bottom: 4px solid
                                                        black;
                                                "
                                            >
                                                Singlepart
                                            </th>
                                            <th
                                                style="
                                                    text-align: center;
                                                    border-bottom: 4px solid
                                                        black;
                                                    font-size: 13px;
                                                    color: black;
                                                "
                                            >
                                                Description
                                            </th>

                                            <th
                                                style="
                                                    text-align: center;
                                                    border-bottom: 4px solid
                                                        black;
                                                    font-size: 13px;
                                                    color: black;
                                                "
                                            >
                                                Qty
                                            </th>
                                            <th
                                                style="
                                                    text-align: center;
                                                    border-bottom: 4px solid
                                                        black;
                                                    font-size: 13px;
                                                    color: black;
                                                "
                                            >
                                                Req.By
                                            </th>
                                            <th
                                                width="20%"
                                                style="
                                                    text-align: center;
                                                    border-right: 2px solid
                                                        black;
                                                    border-bottom: 4px solid
                                                        black;
                                                    font-size: 13px;
                                                    color: black;
                                                "
                                            >
                                                Return
                                            </th>
                                        </tr>
                                        <tr align="center" v-else>
                                            <th
                                                style="
                                                    text-align: center;
                                                    border-top: 2px solid black;
                                                    border-bottom: 2px solid
                                                        black;
                                                    font-size: 13px;
                                                    color: black;
                                                "
                                            >
                                                Type
                                            </th>
                                            <th
                                                style="
                                                    text-align: center;
                                                    border-bottom: 2px solid
                                                        black;
                                                    font-size: 13px;
                                                    color: black;
                                                "
                                            >
                                                CaseID
                                            </th>
                                            <th
                                                style="
                                                    text-align: center;
                                                    border-bottom: 2px solid
                                                        black;
                                                    font-size: 13px;
                                                    color: black;
                                                "
                                            >
                                                Description/S/N
                                            </th>

                                            <th
                                                style="
                                                    text-align: center;
                                                    border-bottom: 2px solid
                                                        black;
                                                    font-size: 13px;
                                                    color: black;
                                                "
                                            >
                                                Qty
                                            </th>
                                            <th
                                                style="
                                                    text-align: center;
                                                    border-bottom: 2px solid
                                                        black;
                                                    font-size: 13px;
                                                    color: black;
                                                "
                                            >
                                                Req.By
                                            </th>
                                            <th
                                                width="20%"
                                                style="
                                                    text-align: center;
                                                    border-right: 2px solid
                                                        black;
                                                    border-bottom: 2px solid
                                                        black;
                                                    font-size: 13px;
                                                    color: black;
                                                "
                                            >
                                                Return
                                            </th>
                                        </tr>
                                        <tr
                                            v-if="
                                                databranch.box_ags.length == 0
                                            "
                                        ></tr>
                                        <tr
                                            v-else
                                            v-for="(
                                                databranchboxags, i
                                            ) in databranch.box_ags[0].packing"
                                            :key="i"
                                        >
                                            <td
                                                align="center"
                                                style="
                                                    border-bottom: 2px solid
                                                        black;
                                                    border-right: 1px solid
                                                        black;
                                                    color: black;
                                                    font-weight: 400;
                                                "
                                            >
                                                {{ databranchboxags.type_name }}
                                            </td>
                                            <td
                                                align="center"
                                                style="
                                                    border-bottom: 2px solid
                                                        black;
                                                    border-right: 1px solid
                                                        black;
                                                    color: black;
                                                    font-weight: 400;
                                                "
                                            >
                                                {{ databranchboxags.case_id }}
                                            </td>
                                            <td
                                                align="center"
                                                style="
                                                    border-bottom: 2px solid
                                                        black;
                                                    border-right: 1px solid
                                                        black;
                                                    color: black;
                                                    font-weight: 400;
                                                "
                                            >
                                                {{ databranchboxags.serial }}
                                            </td>
                                            <td
                                                align="center"
                                                style="
                                                    border-bottom: 2px solid
                                                        black;
                                                    border-right: 1px solid
                                                        black;
                                                    color: black;
                                                    font-weight: 400;
                                                "
                                            >
                                                {{
                                                    databranchboxags.singlepart
                                                }}
                                            </td>
                                            <td
                                                align="center"
                                                style="
                                                    border-bottom: 2px solid
                                                        black;
                                                    border-right: 1px solid
                                                        black;
                                                    color: black;
                                                    font-weight: 400;
                                                "
                                            >
                                                <div>
                                                    <span>{{
                                                        databranchboxags.description
                                                    }}</span>
                                                </div>
                                            </td>
                                            <td
                                                align="center"
                                                style="
                                                    border-bottom: 2px solid
                                                        black;
                                                    border-right: 1px solid
                                                        black;
                                                    color: black;
                                                    font-weight: 400;
                                                "
                                            >
                                                {{ databranchboxags.qty }}
                                            </td>
                                            <td
                                                align="center"
                                                style="
                                                    border-bottom: 2px solid
                                                        black;
                                                    border-right: 1px solid
                                                        black;
                                                    color: black;
                                                    font-weight: 400;
                                                "
                                            >
                                                <div>
                                                    <span>{{
                                                        databranchboxags.created_name
                                                    }}</span>
                                                    <br /><span>{{
                                                        databranchboxags.created_date
                                                    }}</span>
                                                </div>
                                            </td>
                                            <td
                                                align="center"
                                                style="
                                                    border-bottom: 2px solid
                                                        black;
                                                    border-right: 2px solid
                                                        black;
                                                    color: black;
                                                    font-weight: 400;
                                                "
                                            >
                                                <v-btn
                                                    color="blue-grey"
                                                    class="ma-2 white--text"
                                                    fab
                                                    x-small
                                                    @click="
                                                        ReturnPending(
                                                            databranchboxags.detail_id
                                                        )
                                                    "
                                                >
                                                    <v-icon dark
                                                        >mdi-reply</v-icon
                                                    >
                                                </v-btn>
                                            </td>
                                        </tr>
                                    </table>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </div>
</template>
<script>
import axios from "axios"
import { mapState, mapMutations } from "vuex"
export default {
    computed: {
        ...mapState(["isLoading"]),
        ...mapState(["snackbar"]),
        allprovince() {
            return this.selectedProvince.length === this.showbranch.length
        },
        someprovince() {
            return this.selectedProvince.length > 0 && !this.allprovince
        },
        icon() {
            if (this.allprovince) return "mdi-close-box"
            if (this.someprovince) return "mdi-minus-box"
            return "mdi-checkbox-blank-outline"
        },
    },
    data() {
        return {
            selectedProvince: [],
            dialogemail: false,
            chkboxselectall: false,
            chkboxselect: [],
            validacacia: false,
            validaserve: false,
            consignmentnoacacia: [(v) => !!v || "Consignment_No is required"],
            totalboxacacia: [(v) => !!v || "Total_Box is required"],
            consignmentnoaserve: [(v) => !!v || "Consignment_No is required"],
            totalboxaserve: [(v) => !!v || "Total_Box is required"],
            consignmentacacia: "",
            totalacacia: "",
            consignmentags: "",
            totalags: "",
            branchid_select: "",
            dataselect: {
                checked: [],
            },
            select: "",
            datapending: [],
            issuecheck: 0,
            packingcheck: 0,
            transfercheck: 0,
            checkbutton: 0,
            buttonactive: [
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
            ],
            tobox: ["ACACIA", "ASERVE"],
            tobox1: ["ASERVE", "PENDING"],
            tobox2: ["ACACIA", "PENDING"],
            showbranch: [],
            databranch: [],
        }
    },
    mounted() {
        //เปิดหน้านี้ครั้งแรก จะเข้ามาทำที่ mounted ก่อนเป็นอัมดับแรก
        // เรียกฟังชั้น getAjax

        this.getAjax()
    },
    methods: {
        ...mapMutations(["mutateIsLoading"]),
        ...mapMutations(["mutatesnackbar"]),
        toggle() {
            this.$nextTick(() => {
                if (this.allprovince) {
                    this.selectedProvince = []
                } else {
                    this.selectedProvince = this.showbranch.slice()
                }
            })
        },
        selectallpacking() {
            if (this.chkboxselectall == true) {
                for (let i = 0; i < this.databranch.pending.length; i++) {
                    if (this.chkboxselectall == true) {
                        this.databranch.pending[i].select = true
                    }
                }
            } else {
                for (let i = 0; i < this.databranch.pending.length; i++) {
                    if (this.chkboxselectall == false) {
                        this.databranch.pending[i].select = false
                    }
                }
            }
        },
        async SentEmailProvince() {
            this.mutateIsLoading()
            const url = `${process.env.VUE_APP_ROOT_API}/api/logistics/packinglist/send-email`
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            try {
                const { data } = await axios.post(
                    url,
                    { branch: this.selectedProvince },
                    options
                )
                this.dialogemail = false
                this.mutateIsLoading()
            } catch (error) {
                console.log(error)
            }
        },
        async ReturnPending(detail_id) {
            this.mutateIsLoading()
            const url = `${process.env.VUE_APP_ROOT_API}/api/logistics/packinglist/return`
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            try {
                const { data } = await axios.post(
                    url + "/" + this.branchid_select + "/" + detail_id,
                    "",
                    options
                )
                this.databranch = data
                this.datapending = data.pending
                this.mutateIsLoading()
            } catch (error) {
                console.log(error)
            }
        },
        chkNum() {
            if (event.keyCode < 48 || event.keyCode > 57) {
                event.returnValue = false
            }
        },
        reset() {
            this.datapending.select = ""
        },

        async savenameboxsub(packing_no, consignment_no, total_box) {
            const url = `${process.env.VUE_APP_ROOT_API}/api/logistics/packinglist/update`
            // console.log(url);
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            let consignment_no1 = {
                consignment_no: consignment_no,
                total_box: total_box,
            }
            try {
                this.mutateIsLoading()
                const { data } = await axios.post(
                    url + "/" + packing_no,
                    consignment_no1
                )
                this.$swal("บันทึกข้อมูลเรียบร้อยครับ.", {
                    icon: "success",
                    button: false,
                    timer: 1000,
                })
                // console.log(data);
                this.branchpackinglist(this.branchid_select)
                this.mutateIsLoading()
            } catch (error) {
                console.log(error)
            }
        },
        async saveboxtoproject() {
            this.dataselect = {
                checked: [],
            }
            for (let i = 0; i < this.databranch.pending.length; i++) {
                if (this.databranch.pending[i].select === true) {
                    this.dataselect.checked.push(
                        this.databranch.pending[i].detail_id
                    )
                }
            }
            // console.log(this.dataselect, "save");
            this.mutateIsLoading()
            const url = `${process.env.VUE_APP_ROOT_API}/api/logistics/packinglist/branch`
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            try {
                const { data } = await axios.post(
                    url + "/" + this.branchid_select,
                    this.dataselect,
                    options
                )
                this.$swal("บันทึกข้อมูลลงกล่องเรียบร้อยครับ.", {
                    icon: "success",
                    button: false,
                    timer: 1000,
                })
                this.databranch = data
                this.datapending = data.pending
                this.chkboxselectall = false
                this.mutateIsLoading()
            } catch (error) {
                console.log(error)
            }
        },
        async getAjax() {
            const url = `${process.env.VUE_APP_ROOT_API}/api/logistics/packinglist/branch`
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            try {
                this.mutateIsLoading()
                const { data } = await axios.get(url, options)
                this.showbranch = data
                // console.log(this.showbranch, "gg");
                this.mutateIsLoading()
            } catch (error) {
                console.log(error)
            }
        },
        selected(i, id) {
            ;(this.buttonactive = [
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
            ]),
                (this.buttonactive[i] = "1")

            this.branchpackinglist(id)
        },
        async branchpackinglist(branch_id) {
            this.chkboxselectall = false
            const url = `${process.env.VUE_APP_ROOT_API}/api/logistics/packinglist/branch`
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            try {
                this.mutateIsLoading()
                const { data } = await axios.get(url + "/" + branch_id, options)
                // console.log(data, "zzsss");

                this.databranch = []
                this.databranch = data
                if (data.box_acacia.length != 0) {
                    this.consignmentacacia = data.box_acacia[0].consignment_no
                    this.totalacacia = data.box_acacia[0].total_box
                }
                if (data.box_ags.length != 0) {
                    this.consignmentags = data.box_ags[0].consignment_no
                    this.totalags = data.box_ags[0].total_box
                }
                // console.log(this.databranch, "branch");

                this.branchid_select = branch_id
                this.mutateIsLoading()
                this.checkbutton = 1
            } catch (error) {
                console.log(error)
            }
        },
    },
}
</script>
